document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.mobile-menu');
  const menuDrawer = document.querySelector('#MobileMenu');
  const closeButton = document.querySelector('.mobile-menu-close');

  if (menuButton && menuDrawer) {
    menuButton.addEventListener('click', () => {
      menuDrawer.classList.add('open');
    });
  }

  if (closeButton && menuDrawer) {
    closeButton.addEventListener('click', () => {
      menuDrawer.classList.remove('open');
    });
  }
});
